import { render, staticRenderFns } from "./RoleNameEdit.vue?vue&type=template&id=237256a6&scoped=true&"
import script from "./RoleNameEdit.vue?vue&type=script&lang=js&"
export * from "./RoleNameEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleNameEdit.vue?vue&type=style&index=0&id=237256a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237256a6",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237256a6')) {
      api.createRecord('237256a6', component.options)
    } else {
      api.reload('237256a6', component.options)
    }
    module.hot.accept("./RoleNameEdit.vue?vue&type=template&id=237256a6&scoped=true&", function () {
      api.rerender('237256a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/RoleNameEdit.vue"
export default component.exports